import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Alert, Space } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const { Title, Text } = Typography;

const Login = ({ onSwitchToRegister, onSwitchToLogin }) => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    setError('');
    setLoading(true);

    const result = await login(values.username, values.password);
    
    if (!result.success) {
      setError(result.error);
      setLoading(false);
    }
    // On success, AuthContext will update and App.jsx will redirect
  };

  return (
    <div className="auth-container">
      <Card className="auth-card" style={{ maxWidth: 420 }}>
        <Space orientation="vertical" size="large" style={{ width: '100%' }}>
          <div style={{ textAlign: 'center', marginBottom: 8 }}>
            <Title level={2} style={{ margin: 0, marginBottom: 8, color: 'var(--text-primary)' }}>Login to SignBoards</Title>
            <Text type="secondary" style={{ fontSize: 14 }}>IRC:67-2022 Road Sign Generator</Text>
          </div>
          
          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              closable
              onClose={() => setError('')}
            />
          )}
          
          <Form
            form={form}
            name="login"
            onFinish={handleSubmit}
            layout="vertical"
            size="large"
            autoComplete="off"
          >
            <Form.Item
              name="username"
              rules={[{ required: true, message: 'Please enter your username or email' }]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Username or Email"
                autoFocus={false}
              />
            </Form.Item>
            
            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Please enter your password' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Password"
              />
            </Form.Item>
            
            <Form.Item>
              <Button type="primary" htmlType="submit" block loading={loading}>
                Login
              </Button>
            </Form.Item>
          </Form>
          
          <div className="auth-switch" style={{ textAlign: 'center' }}>
            <Text type="secondary">Don't have an account? </Text>
            <Button type="link" onClick={onSwitchToRegister} style={{ padding: 0 }}>
              Register here
            </Button>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default Login;

